/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

=========================================================
*/

// Material Dashboard 2 PRO React base styles
import colors from "dashboard-template/assets/theme-dark/base/colors";
import borders from "dashboard-template/assets/theme-dark/base/borders";

const { white, grey, dark } = colors;
const { borderRadius } = borders;

const notificationWidget = {
  styleOverrides: {
    root: {
      "&.notification-widget": {
        borderRadius: borderRadius.xl,
        boxShadow: "none",
        background: dark.main,
        "& .notification-widget-header": {
          background: "#25324A",

          "& .notification-widget-logo": {
            color: white.main,
          },
          "& .MuiTypography-root": {
            color: white.main,
          },
          "& .MuiIconButton-root": {
            color: white.main,
          },
        },

        "& .MuiListItem-root": {
          backgroundColor: dark.main,
          marginBottom: "8px",
          borderRadius: borderRadius.md,
          transition: "background-color 0.3s",

          "&:hover": {
            backgroundColor: dark.focus,
          },

          "& .MuiTypography-root": {
            color: white.main,
          },
        },
        "& .notification-widget-empty-text": {
          color: grey[500],
        },
        "& .notification-widget-toggle-read": {
          color: white.main,
          fontWeight: 500,
          padding: "6px 12px",
          borderRadius: borderRadius.md,
          textTransform: "none",
          transition: "all 0.2s ease-in-out",

          "& .MuiButton-startIcon, & .MuiButton-startIcon > *": {
            color: white.main,
          },
          "&:selected": {
            color: white.main,
          },
          "&:hover": {
            backgroundColor: grey[700],
            color: white.main,
          },
        },
      },
    },
  },
};

export default notificationWidget;

